import { ErrorMessage } from "formik"
import React from 'react';
import "../../global/GlobalCSS.css";
import { Label } from "reactstrap";
import Select from 'react-select';
import { Opt } from "../../GenericForms/Form.Interface";

interface Props {
    options: any
    label: string;
    name: string;
    [x: string]: any
}


export const CustomSelect = ({ label, options, select_field, ...props }: Props) => {
    return (
        <>
            <Label className="mb-0">{label}</Label>
            <>
                <Select
                    name={props.name}
                    options={options}
                    onChange={props.onChange}
                    getOptionLabel={(option: Opt) => option.desc}
                    getOptionValue={(option: any) => option.value}
                    className='mb-3'
                />
                <ErrorMessage name={props.name} component="span" className="error" />
            </>
        </>
    )
}